import { inherits } from 'util';

export interface editableGridSettings {
    items:Array<any>;
    paging?:boolean;
    print?:boolean;
    default_row:boolean;
    selectall:boolean;
    index:boolean;
    pullSheet:Array<any>;
    add_new:boolean;
    default_row_count:number;
  }
export class editableGrid {
    items:editableGridSettings['items']=[];
    paging?:editableGridSettings['paging']=true;
    print?:editableGridSettings['print']=false;
    default_row?:editableGridSettings['default_row']=false;
    selectall?:editableGridSettings['selectall']=false;
    index?:editableGridSettings['index']=false;
    pullSheet?:editableGridSettings['pullSheet']=[];
    default_row_added?:boolean=false;
    startPage?:number=0;
    limit?:number=10;
    itemsCount?:number=0;
    add_new?:boolean=false;
    filter?:boolean=false;
    page_size:number=10;
    page_no:number=0;
    default_row_count:number=0;
    noCount:boolean=false;
    allowConfigGrid:boolean=true;
    defualt_page_size:number=10;
    barcode_reader:any=false;
    hide_search:boolean=false;
}